module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/black-start-quote-8a7abb5d0f167afc50c43eacbc1b5553.png";